// User account model
// depends on shared global AWS config state, so only one user at a time for now

Cognito, {type CognitoConfig} from ../aws/cognito.civet

{ S3FS } from @danielx/lib

{ promiseChoke } from @danielx/lib

export Account := (AWS, cognitoConfig: CognitoConfig) ->
  // The credentials need to have been populated by cognito.
  id := AWS.config.credentials.identityId

  cognito := Cognito(cognitoConfig)

  bucket := new AWS.S3
    params:
      Bucket: "whimsy-fs"

  refreshCredentials := promiseChoke ->
    // This has the side effect of updating the global AWS object's credentials
    cognito.cachedUser()
    .then (AWS) ->
      // Copy the updated credentials to the bucket
      bucket.config.credentials = AWS.config.credentials
    .catch console.debug

  id: id
  fs: new S3FS(id, bucket, refreshCredentials)
  logout: ->
    cognito.logout()

export default Account
